import React from 'react';
import styled from 'styled-components';
import { Text, useMenuContext } from '@cko/primitives';
import { Suggestion } from './Suggestion';
const suggestionScrollLimit = 6;
const Title = styled(Text) `
  margin: var(--layout-soybean) var(--layout-sandgrain) var(--layout-sandgrain);
  padding: var(--layout-soybean) var(--layout-stamp);
`;
const List = styled.ul `
  list-style-type: none;
  padding: var(--layout-sandgrain);
  margin: var(--layout-sandgrain);
  overflow-y: ${({ numOfSuggestions }) => numOfSuggestions > suggestionScrollLimit ? 'auto' : 'none'};
  max-height: ${({ numOfSuggestions }) => numOfSuggestions > suggestionScrollLimit ? '192px' : 'none'};
`;
export const SuggestionList = ({ title, suggestions }) => {
    const { getMenuProps, getItemProps, highlightedIndex } = useMenuContext();
    if (!suggestions.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, null, title),
        React.createElement(List, { ...getMenuProps(), "data-testid": "suggestions-list", numOfSuggestions: suggestions.length }, suggestions.map((suggestion, i) => {
            const { label, description } = suggestion;
            return (React.createElement("li", { key: label + description, "data-testid": `suggestion-${i}`, ...getItemProps({ item: suggestion, index: i }) },
                React.createElement(Suggestion, { field: label, text: description, isHighlighted: highlightedIndex === i })));
        }))));
};
